/** Org settings — company email domain restriction (SSO-style auto-join). */
export const ACCOUNT_ADMIN_SSO_COPY = {
  TITLE: 'Company sign-in (SSO)',
  BODY:
    'Restrict this organization to users with a specific company email domain. When enabled, new members who sign in with Google using that domain are auto-added — no invite link needed. Existing members are not affected.',
  CHECKBOX_LABEL: 'Restrict to company email domain',
  DOMAIN_PLACEHOLDER: 'acme.com',
  SAVE_BUTTON: 'Save SSO settings',
  INVALID_DOMAIN: 'Enter a valid domain (e.g. acme.com)',
  domainRestricted: (domain: string) => `Domain restricted to @${domain}`,
  DOMAIN_REMOVED: 'Domain restriction removed',
  SAVE_FAILED: 'Could not save SSO settings',
} as const
